<template>
  <v-col cols="12" v-if="visible">
    <span>{{ fileName }}</span>
    <v-progress-linear :model-value="percentage" height="25">
      <strong>{{ percentage }} %</strong>
    </v-progress-linear>
  </v-col>
</template>

<script setup lang="ts">
defineProps<{
  visible: boolean;
  fileName: string;
  percentage: number;
}>();
</script>
